import React from 'react'
import { Box, useMediaQuery } from '@material-ui/core'
import theme, { COLORS } from '../../../styles/theme'
import { css } from 'linaria'
import moment from 'moment'

type ProgressBarProps = {
  currentDate: Date;
}

const classes = {
  progressBarWrapper: css`
    position: absolute;
    top: ${theme.spacing(25)}px;
    left: 50%;
    transform: translateX(-50%);
  `,
  progressBar: css`
    &:first-child {
      border-radius: 2px 0 0 2px;
    }
    &:last-child {
      border-radius: 0 2px 2px 0;
    }
    &.current {
      border-radius: 2px;
      background-color: ${COLORS.secondary};
    }
    background-color: ${COLORS.gray2};
  `
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentDate }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  
  // Calculate the weeks in the current month
  const getWeeksInMonth = (date: Date) => {
    const firstDay = moment(date).startOf('month')
    const lastDay = moment(date).endOf('month')
    return Math.ceil((firstDay.day() + lastDay.date()) / 7)
  }
  
  const weeksInMonth = getWeeksInMonth(currentDate)
  
  // Calculate the week number within the month
  const weekInMonth = moment(currentDate).week() - moment(currentDate).startOf('month').week() + 1

  // If week spans two months, determine the dominant month
  const currentMoment = moment(currentDate)
  const daysInCurrentMonth = currentMoment.daysInMonth()
  const dayOfMonth = currentMoment.date()
  
  // If we're in the last few days of the month, consider next month as dominant
  const isNextMonthDominant = dayOfMonth > daysInCurrentMonth - 3
  
  // Adjust week number - show last section when in last week of current month
  const adjustedWeekNumber = isNextMonthDominant 
    ? weeksInMonth  // Show last section when in last days of current month
    : weekInMonth

  return (
    <Box display="flex" justifyContent="center" mt={2} className={classes.progressBarWrapper}>
      {[...Array(weeksInMonth)].map((_, index) => (
        <Box
          key={index}
          width={!isMobile ? 100 : 50}
          height={6}
          className={`${classes.progressBar} ${index + 1 === adjustedWeekNumber ? 'current' : ''}`}
        />
      ))}
    </Box>
  )
}

export default ProgressBar